export default __webpack_public_path__ + "static/media/deco-img(7).869569d4.png";